import { render, staticRenderFns } from "./UsersCMS.vue?vue&type=template&id=83c06f26&scoped=true&"
import script from "./UsersCMS.vue?vue&type=script&lang=js&"
export * from "./UsersCMS.vue?vue&type=script&lang=js&"
import style0 from "./UsersCMS.vue?vue&type=style&index=0&id=83c06f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c06f26",
  null
  
)

export default component.exports